/**
 * Preços ativos dos planos do SaaS (`club_plan_prices`) — o que o diálogo
 * "Alterar plano" (`PlanUpgradeDialog`) mostra ao lado das features de cada
 * plano.
 *
 * Saiu de dentro do componente (IR-CI-008) quando o diálogo deixou de trocar o
 * plano (11/10/2026: troca de plano só pelo admin da PPS, sem checkout). Só
 * leitura; a tabela é pública para `authenticated`.
 */
import { useQuery } from '@tanstack/react-query';
import { qk } from '@pps/query-keys';
import { supabase } from '@/integrations/supabase/client';

export interface ClubPlanPrice {
  id: string;
  plan_tier: string;
  name: string | null;
  description: string | null;
  price_monthly: number;
}

export function useClubPlanPrices(enabled: boolean) {
  return useQuery({
    queryKey: qk.financial.planPrices,
    enabled,
    staleTime: 5 * 60_000,
    queryFn: async (): Promise<ClubPlanPrice[]> => {
      const { data, error } = await supabase
        .from('club_plan_prices')
        .select('id, plan_tier, name, description, price_monthly')
        .eq('is_active', true)
        .order('price_monthly', { ascending: true });
      if (error) throw error;
      return (data ?? []) as ClubPlanPrice[];
    },
  });
}
